/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_line';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SkipNextCreditLineAutoPaymentRequest": {
                "fields": {
                  "creditLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SkipNextCreditLineAutoPaymentResponse": {
                "fields": {
                  "creditLine": {
                    "type": ".squareup.corporate_card.resources.CreditLine",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SkipNextCreditLineAutoPaymentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SkipNextCreditLineAutoPaymentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SkipNextCreditLineAutoPaymentRequest @ squareup/corporate_card/service/skip_next_credit_line_auto_payment.proto at 10:1
 */
export const SkipNextCreditLineAutoPaymentRequest = $root.lookupType('squareup.corporate_card.service.SkipNextCreditLineAutoPaymentRequest');
fixType(SkipNextCreditLineAutoPaymentRequest, {
  creditLineId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SkipNextCreditLineAutoPaymentRequest);
/**
 * SOURCE SkipNextCreditLineAutoPaymentResponse @ squareup/corporate_card/service/skip_next_credit_line_auto_payment.proto at 21:1
 */
export const SkipNextCreditLineAutoPaymentResponse = $root.lookupType('squareup.corporate_card.service.SkipNextCreditLineAutoPaymentResponse');
fixType(SkipNextCreditLineAutoPaymentResponse);
Builder.createAndAttachToType(SkipNextCreditLineAutoPaymentResponse);